export { default as ViewColumnsIcon } from './ViewColumnsIcon';
